export default "__VITE_ASSET__h9hP4Zn6__"